/**
 *
 */
export default (theme) => {
    const { colors } = theme['foundations-library']
    return {
        favorite: {
            background: ({ variant, bgColor = colors.neutral[800] }) => variant === 'icon' ? 'transparent' : bgColor,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '50%',
            cursor: 'pointer'
        }
    }
}
